import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"; // For translations
// import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useDispatch } from "react-redux";
import InputContainer from "../../pages/citizen/TCPForms/layout/inputContainer";
import ButtonWrapper from "../../pages/citizen/TCPForms/components/Button";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { FaFilePdf } from "react-icons/fa";
import { yesNoRadioList } from "../../pages/citizen/TCPForms/data";
import { updateChecklistReview } from "@egovernments/digit-ui-module-core/src/redux/actions/formPurchasableFar";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

const PurchasableFarChecklist = ({ formData, userInfo, lastEmpRole, setCurrentTab, setRemarksData }) => {
  const { t } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const dispatch = useDispatch();
  const defaultValues = {
    ...formData,
    checklist: {
      ...formData?.checklist,
    },
  };

  console.log("fromChecklist", formData);

  const { control, handleSubmit, watch, reset, setValue, register } = useForm({ defaultValues });
  const firstCheckList = formData?.checklist?.firstCheckList;
  const secondCheckList = formData?.checklist?.secondCheckList;
  const reviewChecklist1 = formData?.checklistReview?.firstCheckList;
  const reviewChecklist2 = formData?.checklistReview?.secondCheckList;
  //Documents fetching and structuring below
  const normalizeDocuments = (docs) => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const documents = normalizeDocuments(formData?.documents) || {};

  let improvedDoc = [];

  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });
  // attaching url to documents below
  const { data: pdfDetails, isLoading: docsLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: improvedDoc?.length > 0 ? true : false,
  });

  let applicationDocs = []; //final ready documnets
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  console.log("applicationDOcs", applicationDocs);
  const proposalDocument = applicationDocs.filter((item) => ["proposalDocument"].includes(item.documentType))?.[0]?.fileStoreId;
  const drawingFile = applicationDocs.filter((item) => ["drawingFile"].includes(item.documentType))?.[0]?.fileStoreId;
  const structuralCertificate = applicationDocs.filter((item) => ["structuralCertificate"].includes(item.documentType))?.[0]?.fileStoreId;
  const parkingProposalDoc = applicationDocs.filter((item) => ["parkingProposalDoc"].includes(item.documentType))?.[0]?.fileStoreId;
  const fireDepartmentCertificate = applicationDocs.filter((item) => ["fireDepartmentCertificate"].includes(item.documentType))?.[0]?.fileStoreId;
  const Modal = useModal();
  const handleInputChange = (name, value) => {
    // Save input value to sessionStorage
    console.log("name", name, "value", value);

    const currentData = JSON.parse(sessionStorage.getItem("checklistReview")) || {};
    console.log("currentData", currentData);

    currentData[name] = value;
    sessionStorage.setItem("checklistReview", JSON.stringify(currentData));
  };
  const [disabledFields, setDisabledFields] = useState({
    buildingHeight: false,
    proposalDocument: false,
    drawingFile: false,
    front: false,
    rear: false,
    ssb1: false,
    ssb2: false,
    structuralSafety: false,
    fireNocRequired: false,
    totalParkingRequired: false,
    totalParkingProposed: false,
    inBasement: false,
    inOpenArea: false,
    inStilt: false,
    existingRoadWidth: false,
    publicSewerageOrSepticTank: false,
    solidWasteDisposal: false,
    rainWaterHarvesting: false,
    solarWaterHeating: false,
    waterSupplyArrangement: false,
    powerSupply: false,
    garbageCollection: false,
  });
  const handleRadioChange = (name, value) => {
    console.log("nameRadio", name, value);

    setDisabledFields((prevState) => ({
      ...prevState,
      [name]: value === "Yes", // Disable the correction field if "Yes" is selected
    }));
  };
  useEffect(() => {
    // Check sessionStorage for saved data
    const storedData = sessionStorage.getItem("checklistReview");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      // Populate form fields with stored data
      Object.keys(parsedData).forEach((key) => {
        setValue(key, parsedData[key]);
      });
    }
  }, [setValue]);
  const onSubmit = (data) => {
    data.checklistReview = {
      ...data.checklistReview,
      lastEmpRole: `${userInfo?.name} , ${lastEmpRole}`,
    };
    setRemarksData("RemarksData");
    console.log("useFormData", data);
    const checklistData = JSON.parse(sessionStorage.getItem("checklistReview"));
    console.log(checklistData, "checkListReviewPrinted");
    dispatch(updateChecklistReview(data));
    Modal("Checklist Updated", `Checklist for <strong>${formData?.applicationNo}</strong> updated.`, "success");
    setCurrentTab(3);
    // Handle form submission
    // handleTabChange(4, data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div
        className="formContainer"
        style={{ marginTop: "18px" }}
        onBlur={(e) => {
          handleInputChange(e.target.name, e.target.value);
        }}
      >
        <div className="formHeaderContainer">
          <h2 className="formHeading">Checklist 1</h2>
        </div>
        <Table bordered className="m-0">
          <thead className="table-header">
            <tr>
              <th style={{ minWidth: "fit-content" }}>Field Name</th>
              <th style={{ minWidth: "fit-content" }}>User Input</th>
              <th style={{ minWidth: "fit-content" }}>Officer Verification</th>
              <th style={{ minWidth: "fit-content" }}>Correction</th>
              <th style={{ minWidth: "fit-content" }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>{t("LABEL_SETBACK_POSITION")}</strong>
              </td>
            </tr>
            {["Front", "Rear", "SSB1", "SSB2"].map((position) => (
              <tr key={position}>
                <td>
                  {`${position} (M)`}
                  <span className="compulsoryField"> *</span>
                </td>
                <td>{firstCheckList?.setbackPosition?.[position.toLowerCase()] || ""}</td>
                <td
                  onChange={(e) => {
                    handleRadioChange(`${[position.toLowerCase()]}`, e.target.value);
                  }}
                >
                  <InputContainer
                    control={control}
                    hasLabel={false}
                    width={"14vw"}
                    defaultValue={`${reviewChecklist1?.setbackPosition?.[position.toLowerCase()]?.verifiedByOfficer}`}
                    name={`checklistReview.firstCheckList.setbackPosition.${position.toLowerCase()}.verifiedByOfficer`}
                    type="radioButton"
                    data={yesNoRadioList}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "Please select any value.",
                      },
                    }}
                  />
                </td>
                <td>
                  <InputContainer
                    type="textInput"
                    name={`checklistReview.firstCheckList.setbackPosition.${position.toLowerCase()}.correction`}
                    control={control}
                    hasLabel={false}
                    defaultValue=""
                    disabled={disabledFields?.[position.toLowerCase()]}
                  />
                </td>
                <td>
                  <InputContainer
                    type="textInput"
                    name={`checklistReview.firstCheckList.setbackPosition.${position.toLowerCase()}.remarks`}
                    control={control}
                    hasLabel={false}
                    defaultValue=""
                  />
                </td>
              </tr>
            ))}
            <tr>
              <td>
                Height of Proposed Building (m)<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.buildingHeight || ""}</td>
              <td onChange={(e) => handleRadioChange("buildingHeight", e.target.value)}>
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.buildingHeight?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.buildingHeight.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.buildingHeight.correction"
                  control={control}
                  hasLabel={false}
                  disabled={disabledFields?.buildingHeight}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.buildingHeight.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            <tr>
              <td>
                Proposal Document (PDF)<span className="compulsoryField"> *</span>
              </td>
              <td>
                <FaFilePdf
                  color="#a10505"
                  style={{ width: "20px", height: "30px" }}
                  onClick={() => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)}
                />
              </td>
              <td>
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.proposalDocument?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.proposalDocument.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.proposalDocument.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={true}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.proposalDocument.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            <tr>
              <td>
                Drawing File (.dwg)<span className="compulsoryField"> *</span>
              </td>
              <td>
                <FaFilePdf
                  color="#a10505"
                  style={{ width: "20px", height: "30px" }}
                  onClick={() => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)}
                />
              </td>
              <td>
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.drawingFile?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.drawingFile.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.drawingFile.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={true}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.drawingFile.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            <tr>
              <td>
                Structural Safety Certificate Applicable<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.structuralSafety || ""}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("structuralSafety", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.structuralSafety?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.structuralSafety.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.structuralSafety.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.structuralSafety}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.structuralSafety.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            {firstCheckList?.structuralSafety === "Yes" && (
              <tr>
                <td>
                  Structural Safety Certificate<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <FaFilePdf
                    color="#a10505"
                    style={{ width: "20px", height: "30px" }}
                    onClick={() => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)}
                  />
                </td>
                <td>
                  <InputContainer
                    control={control}
                    hasLabel={false}
                    defaultValue={reviewChecklist1?.structuralSafetyCert?.verifiedByOfficer}
                    name="checklistReview.firstCheckList.structuralSafetyCert.verifiedByOfficer"
                    type="radioButton"
                    data={yesNoRadioList}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "Please select any value.",
                      },
                    }}
                  />
                </td>
                <td>
                  <InputContainer
                    type="textInput"
                    name="checklistReview.firstCheckList.structuralSafetyCert.correction"
                    control={control}
                    hasLabel={false}
                    defaultValue=""
                    disabled={true}
                  />
                </td>
                <td>
                  <InputContainer
                    type="textInput"
                    name="checklistReview.firstCheckList.structuralSafetyCert.remarks"
                    control={control}
                    hasLabel={false}
                    defaultValue=""
                  />
                </td>
              </tr>
            )}
            <tr>
              <td>
                Is Fire NOC Required?<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.fireNocRequired || ""}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("fireNocRequired", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.fireNocRequired?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.fireNocRequired.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.fireNocRequired.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.fireNocRequired}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.fireNocRequired.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            {firstCheckList?.fireNocRequired == "Yes" && (
              <tr>
                <td>
                  Fire Department Certificate<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <FaFilePdf
                    color="#a10505"
                    style={{ width: "20px", height: "30px" }}
                    onClick={() => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)}
                  />
                </td>
                <td>
                  <InputContainer
                    control={control}
                    hasLabel={false}
                    defaultValue={reviewChecklist1?.fireDepartmentCert?.verifiedByOfficer}
                    name="checklistReview.firstCheckList.fireDepartmentCert.verifiedByOfficer"
                    type="radioButton"
                    data={yesNoRadioList}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "Please select any value.",
                      },
                    }}
                  />
                </td>
                <td>
                  <InputContainer
                    type="textInput"
                    name="checklistReview.firstCheckList.fireDepartmentCert.correction"
                    control={control}
                    hasLabel={false}
                    defaultValue=""
                    disabled={true}
                  />
                </td>
                <td>
                  <InputContainer
                    type="textInput"
                    name="checklistReview.firstCheckList.fireDepartmentCert.remarks"
                    control={control}
                    hasLabel={false}
                    defaultValue=""
                  />
                </td>
              </tr>
            )}

            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>{t("LABEL_PARKING_ARRANGEMENT")}</strong>
              </td>
            </tr>
            <tr>
              <td>
                No. of Parking Required<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.totalParkingRequired || ""}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("totalParkingRequired", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.totalParkingRequired.verifiedByOfficer}
                  name="checklistReview.firstCheckList.totalParkingRequired.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.totalParkingRequired.correction"
                  control={control}
                  hasLabel={false}
                  disabled={disabledFields?.totalParkingRequired}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.totalParkingRequired.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            <tr>
              <td>
                No of Parking Proposed (As per Map)<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.totalParkingProposed || ""}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("totalParkingProposed", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.totalParkingProposed?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.totalParkingProposed.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.totalParkingProposed.correction"
                  control={control}
                  hasLabel={false}
                  disabled={disabledFields?.totalParkingProposed}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.totalParkingProposed.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            <tr>
              <td>
                Proposed Parking Plan<span className="compulsoryField"> *</span>
              </td>
              <td>
                <FaFilePdf
                  color="#a10505"
                  style={{ width: "20px", height: "30px" }}
                  onClick={() => getDocumentByFileStoreId(parkingProposalDoc, setIsPreviewLoading)}
                />
              </td>
              <td>
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.parkingProposalDoc?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.parkingProposalDoc.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProposalDoc.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={true}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProposalDoc.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Parking Provision as per Proposed Plan</strong>
              </td>
            </tr>
            <tr>
              <td>
                In Basement<span className="compulsoryField"> *</span>
              </td>
              <td>No. of Cars: {firstCheckList?.parkingProvision?.inBasement?.cars || ""}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("inBasement", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.parkingProvision?.inBasement?.cars?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.parkingProvision.inBasement.cars.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inBasement.cars.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.inBasement}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inBasement.cars.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            {/* <tr>
              <td>No. of ECS: {firstCheckList?.parkingProvision?.inBasement?.ecs || ""}</td>
              <td>
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.parkingProvision?.inBasement?.ecs?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.parkingProvision.inBasement.ecs.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inBasement.ecs.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inBasement.ecs.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr> */}

            <tr>
              <td>
                In Open Area<span className="compulsoryField"> *</span>
              </td>
              <td>No. of Cars: {firstCheckList?.parkingProvision?.openArea?.cars || ""}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("inOpenArea", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.parkingProvision?.openArea?.cars?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.parkingProvision.openArea.cars.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.openArea.cars.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.inOpenArea}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.openArea.cars.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            {/* <tr>
              <td>No. of ECS: {firstCheckList?.parkingProvision?.openArea?.ecs || ""}</td>
              <td>
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.parkingProvision?.openArea?.ecs?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.parkingProvision.openArea.ecs.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.openArea.ecs.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.openArea.ecs.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr> */}

            <tr>
              <td>
                In Stilt Area<span className="compulsoryField"> *</span>
              </td>
              <td>No. of Cars: {firstCheckList?.parkingProvision?.inStiltArea?.cars || ""}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("inStilt", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.parkingProvision?.inStiltArea?.cars?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.parkingProvision.inStiltArea.cars.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inStiltArea.cars.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.inStilt}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inStiltArea.cars.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            {/* <tr>
              <td>No. of ECS: {firstCheckList?.parkingProvision?.inStiltArea?.ecs || ""}</td>
              <td>
                <InputContainer
                  control={control}
                  hasLabel={false}
                  defaultValue={reviewChecklist1?.parkingProvision?.inStiltArea?.ecs?.verifiedByOfficer}
                  name="checklistReview.firstCheckList.parkingProvision.inStiltArea.ecs.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inStiltArea.ecs.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.firstCheckList.parkingProvision.inStiltArea.ecs.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr> */}
          </tbody>
        </Table>
      </div>
      <div
        className="formContainer"
        style={{ marginTop: "18px" }}
        onBlur={(e) => {
          handleInputChange(e.target.name, e.target.value);
        }}
      >
        <div className="formHeaderContainer">
          <h2 className="formHeading">Checklist 2</h2>
        </div>
        <Table bordered className="table-checklistReview">
          <thead className="table-header">
            <tr>
              <th style={{ minWidth: "fit-content" }}>Field Name</th>
              <th style={{ minWidth: "fit-content" }}>User Input</th>
              <th style={{ minWidth: "fit-content" }}>Officer Verification</th>
              <th style={{ width: "28%" }}>Correction</th>
              <th style={{ width: "28%" }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Existing road width in meters<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.existingRoadWidth}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("existingRoadWidth", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.roadConnectivity.existingRoadWidth.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.roadConnectivity.existingRoadWidth.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.existingRoadWidth}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.roadConnectivity.existingRoadWidth.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            <tr>
              <td>
                Provision of Sewerage & Drainage<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.publicSewerageOrSepticTank}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("publicSewerageOrSepticTank", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.sewerage.drainagePlanApproval.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.sewerage.drainagePlanApproval.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.publicSewerageOrSepticTank}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.sewerage.drainagePlanApproval.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            <tr>
              <td>
                Provision of Water Supply<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.waterSupplyArrangement ? "Yes" : "No"}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("waterSupplyArrangement", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.waterSupply.waterSupplyArrangement.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.waterSupply.waterSupplyArrangement.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.waterSupplyArrangement}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.waterSupply.waterSupplyArrangement.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            {/* Continue with other sections in a similar pattern... */}

            {/* Water Supply Section */}
            {/* <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Water Supply</strong>
              </td>
            </tr> */}
            <tr>
              <td>
                Mode of Solid waste disposal<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.solidWasteDisposal}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("solidWasteDisposal", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.waste.solidWasteDisposal.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.waste.solidWasteDisposal.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.solidWasteDisposal}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.waste.solidWasteDisposal.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            <tr>
              <td>
                Mode of Garbage collection<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.garbageCollection}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("garbageCollection", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.waste.garbageCollection.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.waste.garbageCollection.correction"
                  control={control}
                  disabled={disabledFields?.garbageCollection}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.waste.garbageCollection.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            <tr>
              <td>
                Provision of Power supply<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.powerSupply ? "Yes" : "No"}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("powerSupply", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.power.powerSupply.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.power.powerSupply.correction"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                  disabled={disabledFields?.powerSupply}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.power.powerSupply.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>

            <tr>
              <td>
                Provision of Rain Water Harvesting
                <span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.rainWaterHarvesting ? "Yes" : "No"}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("rainWaterHarvesting", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.water.rainWaterHarvesting.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.water.rainWaterHarvesting.correction"
                  control={control}
                  disabled={disabledFields?.rainWaterHarvesting}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.water.rainWaterHarvesting.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
            <tr>
              <td>
                Provision of Solar Water Heating system
                <span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.solarWaterHeating ? "Yes" : "No"}</td>
              <td
                onChange={(e) => {
                  handleRadioChange("solarWaterHeating", e.target.value);
                }}
              >
                <InputContainer
                  control={control}
                  hasLabel={false}
                  name="checklistReview.secondCheckList.solarWaterSystem.solarWaterHeating.verifiedByOfficer"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.sewerageDisposal.solarWaterHeating.correction"
                  control={control}
                  hasLabel={false}
                  disabled={disabledFields?.solarWaterHeating}
                  defaultValue=""
                />
              </td>
              <td>
                <InputContainer
                  type="textInput"
                  name="checklistReview.secondCheckList.sewerageDisposal.solarWaterHeating.remarks"
                  control={control}
                  hasLabel={false}
                  defaultValue=""
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className="footerContainer" style={{ marginTop: "18px" }}>
        <div className="buttonWrapper">
          <ButtonWrapper variant="contained" color="success" size="medium" label={t("Save Remarks")} type="submit" />
        </div>
      </div>
    </form>
  );
};

export default PurchasableFarChecklist;
